import { FloorplanToolBase } from './FloorplanToolBase';
import { ViewModes } from '../../helpers';
import type { IViewConfig } from '../../types';

/**
 * Selection tool for STRUCTURE annotations. Mirrors `RoomSelectionTool`: a
 * no-op host that just sits in the structure mode's toolbar slot so the user
 * has something to enable when they aren't drawing. Picking and selection
 * itself is handled by the persona's shared selection plumbing.
 */
export class StructureSelectionTool extends FloorplanToolBase {

  /** Tab selection tool: show the floors elevation map for orientation/switching. */
  protected showsFloorBars(): boolean {
    return true;
  }
  readonly name = 'structure_selection';

  getViewConfig(): IViewConfig {
    return {
      views: [ViewModes.PERSPECTIVE_3D_RGB, ViewModes.XRAY_2D],
      defaultViewId: ViewModes.PERSPECTIVE_3D_RGB.id,
    };
  }
}
